export function DeepEqual<T>(obj1: T, obj2: T): boolean {
  if (obj1 === obj2) return true; // primitives equality check

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false; // fails equality if either is not an object or is null
  }

  const keys1 = Object.keys(obj1) as Array<keyof T>;
  const keys2 = Object.keys(obj2) as Array<keyof T>;

  if (keys1.length !== keys2.length) return false; // object keys equality check

  for (const key of keys1) {
    if (!keys2.includes(key)) return false; // object keys equality check
    if (!DeepEqual(obj1[key], obj2[key])) return false; // recursively comparing
  }

  return true;
}
